import type { FC } from 'react';
import type { Match, WrestlerInMatch } from '../../../types';
import { BoxWhenFatalorTagMatchContainer, DefaultContainerCard, RowOpponentWhenTwoWrestlerInBox, TopDecorColor } from './GenericComponentCssMatchCard';
import CenterInfoFightComponentRender, { AvatarWrestlerWhenThreeOrFourWrestlerInMatch } from './GenericComponentMatchCard';


interface TripleMatchCardProps {
    matchInfo: Match;
    keyMatchInfo: number | string;
    navigateToWrestler: (wrestler: WrestlerInMatch) => void;
}

const TripleMatchCard: FC<TripleMatchCardProps> = ({ matchInfo, keyMatchInfo, navigateToWrestler }) => {
    return (
        <DefaultContainerCard>
            <TopDecorColor />

            <BoxWhenFatalorTagMatchContainer className="box-opponents-container-left">

                <RowOpponentWhenTwoWrestlerInBox className="row-opponent row-opponent-left">
                    <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                        wrestler={matchInfo.wrestlers[0]}
                        win_by_dq={matchInfo.win_by_dq}
                        navigateToWrestler={navigateToWrestler}
                    />

                    <h6 className="opponent-name">{matchInfo.wrestlers[0].name}</h6>
                </RowOpponentWhenTwoWrestlerInBox>

                <RowOpponentWhenTwoWrestlerInBox className="row-opponent row-opponent-left">
                    <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                        wrestler={matchInfo.wrestlers[1]}
                        win_by_dq={matchInfo.win_by_dq}
                        navigateToWrestler={navigateToWrestler}
                    />

                    <h6 className="opponent-name">{matchInfo.wrestlers[1].name}</h6>
                </RowOpponentWhenTwoWrestlerInBox>

            </BoxWhenFatalorTagMatchContainer>

            <CenterInfoFightComponentRender nameMatch="Triple Threat" matchInfo={matchInfo} />

            <BoxWhenFatalorTagMatchContainer className="box-opponents-container-right">

                <RowOpponentWhenTwoWrestlerInBox className="row-opponent row-opponent-right">
                    <h6 className="opponent-name">{matchInfo.wrestlers[2].name}</h6>

                    <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                        wrestler={matchInfo.wrestlers[2]}
                        win_by_dq={matchInfo.win_by_dq}
                        navigateToWrestler={navigateToWrestler}
                    />
                </RowOpponentWhenTwoWrestlerInBox>

            </BoxWhenFatalorTagMatchContainer>
        </DefaultContainerCard>
    );
};

export default TripleMatchCard;
